import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
    InputLabel,
    MenuItem,
    Select,
    FormControl,
    FormControlLabel,
    FormGroup,
    Typography
} from '@mui/material';
import { fetchDspCompanies } from '../../../API/FinancialTools';
import useApi from '../../../hooks/useApi';
import { IOSSwitch } from '../../../components/UI/CustomizedSwitches';

function EditAdtCompanyDialog({ open, handleClose, data, onChange, onSave }) {
    const { data: dspList = [], loading: loadingDsp } = useApi(fetchDspCompanies);

    const [enableWhiteListRemoval, setEnableWhiteListRemoval] = useState(false);

    useEffect(() => {
        if (open) {
            setEnableWhiteListRemoval(data.remove_all === true || !!data.threshold);
        }
    }, [open, data]);

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Edit {data.company_name}</DialogTitle>
            <DialogContent sx={{ minWidth: '450px' }}>
                <TextField fullWidth margin="dense" name="company_name" label="Company Name" value={data.company_name || ''} onChange={onChange} />
                <TextField fullWidth margin="dense" name="adt_domain_name" label="Adtimizer Domain" value={data.adt_domain_name || ''} onChange={onChange} />

                <FormControl fullWidth margin="dense">
                    <InputLabel id="dsp-label">iRTB DSP ID</InputLabel>
                    <Select
                        labelId="dsp-label"
                        id="irtb_id_dsp"
                        name="irtb_id_dsp"
                        value={data.irtb_id_dsp || ''}
                        onChange={onChange}
                        disabled={loadingDsp}
                        required
                    >
                        {dspList.map((item) => (
                            <MenuItem key={item.value.id} value={item.value.id}>
                                {item.value.name} (ID: {item.value.id})
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField fullWidth margin="dense" name="sh_id" label="SmartHub ID" type="number" value={data.sh_id || ''} onChange={onChange} />
                <TextField fullWidth margin="dense" name="wl_id_web" label="WEB White List" type="number" value={data.wl_id_web || ''} onChange={onChange} />
                <TextField fullWidth margin="dense" name="wl_id_inapp" label="INAPP White List" type="number" value={data.wl_id_inapp || ''} onChange={onChange} />
                <TextField fullWidth margin="dense" name="wl_id_ctv" label="CTV White List" type="number" value={data.wl_id_ctv || ''} onChange={onChange} />

                <FormGroup
                    sx={{
                        mt: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '20px'
                    }}
                >
                    <FormControlLabel
                        control={
                            <IOSSwitch
                                checked={enableWhiteListRemoval}
                                onChange={(e) => setEnableWhiteListRemoval(e.target.checked)}
                            />
                        }
                        label={
                            <Typography
                                sx={{
                                    fontSize: '0.95rem',
                                    color: 'text.primary',
                                    marginLeft: '10px',
                                    fontWeight: 500
                                }}
                            >
                                Enable removing from the white list
                            </Typography>
                        }
                    />
                </FormGroup>

                {enableWhiteListRemoval && (
                    <>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="remove-all-label">Remove All</InputLabel>
                            <Select
                                labelId="remove-all-label"
                                name="remove_all"
                                value={data.remove_all?.toString() ?? 'false'}
                                onChange={onChange}
                            >
                                <MenuItem value="false">No</MenuItem>
                                <MenuItem value="true">Yes</MenuItem>
                            </Select>
                        </FormControl>

                        {data.remove_all === false || data.remove_all === 'false' ? (
                            <TextField
                                fullWidth
                                margin="dense"
                                name="threshold"
                                label="Threshold"
                                type="number"
                                value={data.threshold || ''}
                                onChange={onChange}
                            />
                        ) : null}
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={onSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}

export default EditAdtCompanyDialog;
